/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DashboardSummary
 */
export interface DashboardSummary {
    /**
     * 
     * @type {number}
     * @memberof DashboardSummary
     */
    totalInitiatives?: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardSummary
     */
    atRiskCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardSummary
     */
    exceptionsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardSummary
     */
    gapAboveThresholdCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardSummary
     */
    chronicOverdueCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardSummary
     */
    scoreRegressionCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardSummary
     */
    pastTargetDateCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardSummary
     */
    upcomingQuarterlyCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardSummary
     */
    upcomingYearlyCount?: number;
}

/**
 * Check if a given object implements the DashboardSummary interface.
 */
export function instanceOfDashboardSummary(value: object): value is DashboardSummary {
    return true;
}

export function DashboardSummaryFromJSON(json: any): DashboardSummary {
    return DashboardSummaryFromJSONTyped(json, false);
}

export function DashboardSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'totalInitiatives': json['totalInitiatives'] == null ? undefined : json['totalInitiatives'],
        'atRiskCount': json['atRiskCount'] == null ? undefined : json['atRiskCount'],
        'exceptionsCount': json['exceptionsCount'] == null ? undefined : json['exceptionsCount'],
        'gapAboveThresholdCount': json['gapAboveThresholdCount'] == null ? undefined : json['gapAboveThresholdCount'],
        'chronicOverdueCount': json['chronicOverdueCount'] == null ? undefined : json['chronicOverdueCount'],
        'scoreRegressionCount': json['scoreRegressionCount'] == null ? undefined : json['scoreRegressionCount'],
        'pastTargetDateCount': json['pastTargetDateCount'] == null ? undefined : json['pastTargetDateCount'],
        'upcomingQuarterlyCount': json['upcomingQuarterlyCount'] == null ? undefined : json['upcomingQuarterlyCount'],
        'upcomingYearlyCount': json['upcomingYearlyCount'] == null ? undefined : json['upcomingYearlyCount'],
    };
}

export function DashboardSummaryToJSON(json: any): DashboardSummary {
    return DashboardSummaryToJSONTyped(json, false);
}

export function DashboardSummaryToJSONTyped(value?: DashboardSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalInitiatives': value['totalInitiatives'],
        'atRiskCount': value['atRiskCount'],
        'exceptionsCount': value['exceptionsCount'],
        'gapAboveThresholdCount': value['gapAboveThresholdCount'],
        'chronicOverdueCount': value['chronicOverdueCount'],
        'scoreRegressionCount': value['scoreRegressionCount'],
        'pastTargetDateCount': value['pastTargetDateCount'],
        'upcomingQuarterlyCount': value['upcomingQuarterlyCount'],
        'upcomingYearlyCount': value['upcomingYearlyCount'],
    };
}

